import { Button, Col, Row } from 'antd'
import React from 'react'
import './MobFootball.scss'
import FootballImg from '../../assets/img/Group-desk.png'
import FootballImgMobile from '../../assets/img/Group-mobile.png'
import { useMediaQuery } from 'react-responsive'

const APARAT_VIDEO_SRC = 'https://www.aparat.com/video/video/embed/videohash/rko93l5/vt/frame?titleShow=true&recom=self'

function AparatVideo() {
  return (
    <div className="h_iframe-aparat_embed_frame">
      <span className="ratio" />
      <iframe
        src={APARAT_VIDEO_SRC}
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        title="ویدیو بیمه دات کام"
      />
    </div>
  )
}

function ThirdSectionText() {
  return (
    <div className='football-text'>
      چون تو این زمین می‌تونی:
      <br />
      ✔ قبل و بعد از خرید بیمه، <strong>مشاورهٔ رایگان</strong> بگیری.
      <br />
      ✔ شرایط همهٔ شرکت‌بیمه‌ها رو یک‌جا <strong>مقایسه</strong> کنی.
      <br />
      ✔ <strong>۲۴ ساعته، ۷ روز هفته</strong>، سوالاتت رو با ما در میون بذاری.
      <br />
      ✔ بسته به انتخابت، بیمه‌ت رو <strong>نقدی یا قسطی</strong> خریداری کنی.
      <br />
      ✔ با <strong>صدور فوری</strong> بیمه‌ت (زیر یک ساعت)، خیالت رو راحت کنی!
    </div>
  )
}

export default function Index({ type }) {
  const isMobile = useMediaQuery({ maxWidth: 921 })

  return (
    <div>
      {
        type === 0 ? (
          <Row className='football-section first-container'>
            {isMobile && (<h2 className='w-100 text-center'>پاس گل قهرمانی!</h2>)}
            <Col xs={24} lg={14} className='image-col'>
              <img
                src={isMobile ? FootballImgMobile : FootballImg}
                alt='football'
                className='football-img'
              />
            </Col>
            <Col xs={24} lg={10} className='mt-1 text-col'>
              <div className='text-with-arc text-with-arc--outer-end'>
                {!isMobile && (<h2>پاس گل قهرمانی!</h2>)}
                <div className='football-text'>
                  <p className='mb-0'>
                    دقیقه ۹۰ بازیه و نتیجه، مساوی.
                    <br />
                    برای برنده‌شدن به یه گل احتیاج داری.
                    <br />
                    اما نگران نباش. بیمه‌دات‌کام رو کنارت داری!
                    <br />
                    می‌تونی همین حالا ثبت‌نام کنی، اعتبار هدیه بگیری،
                    <br />
                    و با استفاده از اعتبارت، بیمه بخری و گل پیروزی رو بزنی!
                    <br />
                    یادت نره؛ برای گرفتن هدیه‌ت، <strong>فقط تا آخر جام‌جهانی</strong> وقت داری.
                  </p>
                </div>
              </div>
              <Button
                className='buttonGift'
                type='primary'
                size='large'
                onClick={() => {
                  document.getElementById('world-cup-hero').scrollIntoView({ behavior: 'smooth' })
                }}
              >
                دریافت هدیه
              </Button>
            </Col>
          </Row>
        ) : (
          <Row className='football-section  second-container'>
            {
              isMobile ? (
                <>
                  <Col xs={24} className='mobile-heading-col'>
                    <h2 className='mobile-section-heading'>چرا بازی تو زمین بیمه‌دات‌کام؟</h2>
                  </Col>
                  <Col xs={24} className='video video-col'>
                    <AparatVideo />
                  </Col>
                  <Col xs={24} className='text-col'>
                    <ThirdSectionText />
                  </Col>
                </>
              ) : (
                <>
                  <Col xs={24} lg={12} className='text-col'>
                    <div className='text-with-arc text-with-arc--outer-start'>
                      <h2>چرا بازی تو زمین بیمه‌دات‌کام؟</h2>
                      <ThirdSectionText />
                    </div>
                  </Col>
                  <Col xs={24} lg={12} className='video video-col'>
                    <AparatVideo />
                  </Col>
                </>
              )
            }
          </Row>
        )
      }
    </div>
  )
}
